import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-14_cxa6ui.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-15_f8ob9q.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-16_gytgsu.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">

        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 mt-2 md:mb-6  text-[#152C24]">RESEARCH INSTITUTIONS</h1>

        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281937/image-5_xtxfry.png"
          alt="Research in Agriculture"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        <div className="flex-1">
          <section className="bg-white p-6">
            <h2 className="text-[32px] font-bold text-[#152C24] mb-6">
              <strong className="font-bold text-black">RESEARCH INSTITUTIONS:</strong> How can they benefit?
            </h2>

            <h2 className="font-bold text-[32px] text-black mb-6">
              Agricultural researchers, rural development experts, and innovation teams can benefit from the Farmnet App in multiple impactful ways:
            </h2>

            <div className="md:space-y-10 text-[32px] text-[#152C24] mt-10">
              <div>
                <strong>1. Access to Real-Time, Field-Level Data</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Collect geo-tagged data on crops, inputs, yields, and weather.</li>
                  <li>Build accurate, up-to-date datasets for evidence-based research.</li>
                </ul>
              </div>

              <div>
                <strong>2. Easier Farmer Surveys & Data Collection</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Use digital forms to gather responses directly in the app.</li>
                  <li>Lower costs and reduce manual errors in data collection.</li>
                </ul>
              </div>

              <div>
                <strong>3. Longitudinal Studies & Monitoring</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Track practices and outcomes over time for impact studies.</li>
                  <li>Ideal for climate resilience and adoption behavior research.</li>
                </ul>
              </div>

              <div>
                <strong>4. Rapid Dissemination of Findings</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Share research insights and best practices instantly with users.</li>
                  <li>Bridge the gap between research outputs and real-world usage.</li>
                </ul>
              </div>

              <div>
                <strong>5. Collaborate with Multiple Stakeholders</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Work with farmers, NGOs, and education institutions in one ecosystem.</li>
                  <li>Facilitate cross-sectoral innovation and value chain research.</li>
                </ul>
              </div>

              <div>
                <strong>6. Testing and Scaling Innovations</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Pilot tools or practices with select farmer groups on the platform.</li>
                  <li>Gather adoption data and scale successful approaches faster.</li>
                </ul>
              </div>

              <div>
                <strong>7. Disaggregated Data for Inclusive Research</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Filter and analyze data by region, gender, or farm size.</li>
                  <li>Support inclusive research and policy recommendations.</li>
                </ul>
              </div>

              <div>
                <strong>8. Integration with Geospatial & Climate Tools</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Link Farmnet with satellite or weather datasets.</li>
                  <li>Enable smart agriculture studies and climate risk modeling.</li>
                </ul>
              </div>

              <div>
                <strong>9. Publishing and Policy Influence</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Use verified datasets for journals, briefs, or funding proposals.</li>
                  <li>Back your research with real, farmer-driven evidence.</li>
                </ul>
              </div>

              <div>
                <strong>✅ 10. Accelerates Research-to-Impact</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Create a continuous feedback loop from research to farmers.</li>
                  <li>Speed up the adoption of proven insights and innovations.</li>
                </ul>
              </div>

            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Solutions2;
